import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { Translate, withLocalize } from 'react-localize-redux';
import PropTypes from 'prop-types';

import jaLocale from './ja.locale.js';

/**
 * SEO component
 */
class SEO extends PureComponent {
  constructor(props) {
    super(props);
    this.props.addTranslationForLanguage(jaLocale, 'ja');
  }

  render() {
    const { gameId } = this.props;

    return (
      <Translate>
        {({ translate }) => {
          let title = translate('seo.default.title');
          let description = translate('seo.default.description');
          let ogDescription = description;
          let ogImage = translate('seo.default.ogImage');
          let ogUrl = translate('seo.default.ogUrl');
          let twitterCard = 'summary';
          let favicon = translate('seo.default.favicon');

          if (gameId) {
            title = `${translate(`seo.games.${gameId}.title`)} | ${translate(
              'seo.default.title'
            )}`;
            description = translate(`seo.games.${gameId}.description`);
            ogDescription =
              translate(`seo.games.${gameId}.ogDescription`) || description;
            ogImage = translate(`seo.games.${gameId}.ogImage`);
            ogUrl = translate(`seo.games.${gameId}.ogUrl`);
            twitterCard = 'summary_large_image';
            favicon = translate(`seo.games.${gameId}.favicon`) || favicon;
          }

          return (
            <Helmet title={title}>
              <meta content="233763560659727" property="fb:app_id" />
              <meta content="website" property="og:type" />
              <meta content="ja_JP" property="og:locale" />
              <meta content={description} name="description" />
              <meta content={title} property="og:title" />
              <meta content={ogDescription} property="og:description" />
              <meta content={ogImage} property="og:image" />
              <meta content={ogUrl} property="og:url" />
              <meta content={twitterCard} name="twitter:card" />
              <link href={favicon} rel="shortcut icon" />
              <link
                href={translate('seo.default.ogImage')}
                rel="apple-touch-icon"
              />
            </Helmet>
          );
        }}
      </Translate>
    );
  }
}

SEO.propTypes = {
  gameId: PropTypes.string
};

export default withLocalize(SEO);
